// Участники и прогресс пересчитываются воркером, сервер не пушит по WS.
export const RAFFLE_POLLING_MS = 60_000;

// После ends_at бэку нужно время, чтобы закрыть розыгрыш.
export const RAFFLE_END_GRACE_MS = 3_000;

export const RAFFLES_PER_PAGE = 10;
